import React from "react";
import "../assets/styles/ScreenSizeError.css";
import { ReactComponent as IDVLogo } from "../idv-logo.svg";
import Header from "./Header";
import { TOEFL_PROGRAM_ID } from "../constants/Constants";

const ScreenSizeError = ({ errorTitle, errorMsg }) => {
  const programId = sessionStorage.getItem("program_id");
  return (
    <div
      className={`screen-size-error ${
        programId == TOEFL_PROGRAM_ID
          ? "toefl-landing-page-bg"
          : "gre-landing-page-bg"
      }`}
    >
      <Header />

      <div className="error-screen-content-container">
        <div className="error-screen-icon-container"></div>

        <div className="error-screen-message-container">
          <h1 className="error-screen-title">{errorTitle}</h1>
          <p className="error-screen-message">{errorMsg}</p>
        </div>
      </div>
    </div>
  );
};

export default ScreenSizeError;
